import { useSyncExternalStore } from 'react';

// ============================================================================
// AI-summary feature switch (Leo 2026-07-13): Settings→Advanced toggle, DEFAULT
// ENABLED. MEMORY-ONLY by design for now — resets on reload; backend persistence
// is the recorded follow-up (NEVER localStorage — standing no-client-storage
// rule). Module-level store so ALL consumers (legacy ValueChart + RendererV1
// trend details) share one flag without prop-drilling through the shell.
// ============================================================================

let aiSummaryOn = true;
const listeners = new Set<() => void>();

export const setAiSummaryEnabled = (v: boolean) => {
  aiSummaryOn = v;
  listeners.forEach((l) => l());
};

export const useAiSummaryEnabled = (): boolean =>
  useSyncExternalStore(
    (cb) => { listeners.add(cb); return () => { listeners.delete(cb); }; },
    () => aiSummaryOn
  );
